<!-- <template>
<span
  class="pcqb-tabs-label"
  :class="{active: isActive}"
  @click="clickHandler"
>{{label}}</span>
</template> -->
<script>
export default {
  data() {
    return {
      activeName: '',
      isActive: false,
      hoverable: false
    };
  },
  props: {
    name: String,
    label: String,
    issub: Boolean,
    dataLog: String,
    dataXlog: String
  },
  watch: {
    activeName(v, ov) {
      this.isActive = v === this.name;
      // console.log('watch.activeName', this.name, v, ov, this.isActive);
    }
  },
  methods: {
    clickHandler() {
      this.$parent.$emit('tab.change', this.name, this);
      // console.log('tab.click', this);
    },
    mouseenterHandler() {
      if (!this.hoverable) return;
      // console.log('tab.mouseenter', this);
      this.$parent.$emit('tab.change', this.name, this);
    }
  },
  render(h) {
    let _attrs = {};
    this.dataLog && (_attrs['data-log'] = this.dataLog);
    this.dataXlog && (_attrs['data-xlog'] = this.dataXlog);

    return  h(
      'span',
      {
        class: {
          active: this.isActive,
          'pcqb-subtabs': this.issub,
          'pcqb-tabs-label-wrap': true
        }
      }, [
        h('span', {
          class: { 'pcqb-tabs-label': true },
          attrs: _attrs,
          on: {
            click: this.clickHandler,
            mouseenter: this.mouseenterHandler
          }
        }, this.label),
        this.$slots.default
      ]
    );
  }
};
</script>
<style lang="less">
.pcqb-tabs-label-wrap{
  display: inline-block;
  &.active{
    > .pcqb-tabs-label{
      color: #fa7d1d!important;
    }
  }
}
.pcqb-tabs-label{
  display: inline-block;
  cursor: pointer;
}
</style>